import React, { useState } from 'react'
import { Modal, ModalBody } from "react-bootstrap";
import ModalHeader from "../../../Setup/Shared/ModalHeader"
import ModalFooter from '../../../Setup/Shared/ModalFooter';
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList";
import { enumUtil } from '../../../../utils/Enum';
import { isNull } from 'lodash';

const MergeCaregiver = ({mergeEvent, onClose}) => {

    let Merge_Modal = {
        FirstCaregiver:'',
        SecondCaregiver:'',
    }
    const API_URl = enumUtil.controller.Claim;
    const [mainMergeCaregiverModal, setMainMergeCaregiverModal] = useState(Merge_Modal);
    const [saveMergeCaregiverModal, setSaveMergeCaregiverModal] = useState({});
    const [patientBody, setCaregiverBody] = useState({"TableName": '', "SearchParam": ''});
    const [patientName, setCaregiverName] = useState(null);
    const [is, setIs] = useState(null)
    //////////////////// Caregiver Search and Select Caregiver
    const handlePateintChange = (e) => {
        setIs(false);
        let modal = {...mainMergeCaregiverModal};
        let saveModal = {...saveMergeCaregiverModal};
        let { name, value } = e.target;
        modal[name] = value;
        setCaregiverName(value);
        setMainMergeCaregiverModal(modal);
        for(let property in modal){
            if(property === name){
                saveModal[name] = value
            }
        }
        setSaveMergeCaregiverModal(saveModal)


        // let modal = { ...mainAppointmentModal };
        // modal[name] = value;
        // setMainAppointmentModal(modal)
        setCaregiverBody({ "TableName": enumUtil.enumAPITableName.Caregiver, "SearchParam": value })
    }
    
    const  handleSelectedData = (selectedData, name, type) => {
        console.log('+++',selectedData,name)
        let modal = {...mainMergeCaregiverModal};
        let saveModal = {...saveMergeCaregiverModal};
        if(!isNull(selectedData)){
            modal[name] = selectedData?.display;
            saveModal[name] = selectedData?.value
        }
        setMainMergeCaregiverModal(modal)
        setSaveMergeCaregiverModal(saveModal)
        console.log('...',mainMergeCaregiverModal,saveMergeCaregiverModal)
    }
    const Pateint = () => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '14px', fontWeight: '600', margin: 'auto' }}>Merge Caregivers</p>;
    };

    return (
        <div>
            <Modal show={mergeEvent} onHide={mergeEvent} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 add_merge_patient">
                <Modal.Body>
                    <ModalHeader HeaderName={Pateint} DeletePopup={""} isClosed={onClose} key={631} Name={'MergeCaregiver'} />

                    <div className='mb-2'>
                        <p className='text'>Merge Duplicate Accounts</p>
                    </div>
                    <div className='d-flex gap-3 mb-3'>
                        <div className='w-100'>
                            <SuperSearchList
                                type='server'
                                id='FirstCaregiver'
                                name='FirstCaregiver'
                                method='post'
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                onChange={handlePateintChange}
                                // value={mainMergeCaregiverModal.FirstCaregiver}
                                icon={true}
                                searchValue={mainMergeCaregiverModal.FirstCaregiver}
                                ApiLink={API_URl + "/CaregiverInstantSearch"}
                                postBody={patientBody}
                                getSelectedData={handleSelectedData}
                                is={is}
                                // disabled={true}
                                placeholder={false}
                                autocomplete={false}
                            />
                        </div>
                        <div className='ar-info d-flex justify-content-center align-items-center'>
                            <p className='heading'>Info</p>
                        </div>
                    </div>
                    <div className='d-flex gap-3 mb-2'>
                        <div className='w-100'>
                            <SuperSearchList
                                type='server'
                                id='SecondCaregiver'
                                name='SecondCaregiver'
                                method='post'
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                onChange={handlePateintChange}
                                value={mainMergeCaregiverModal.SecondCaregiver}
                                icon={true}
                                searchValue={mainMergeCaregiverModal.SecondCaregiver}
                                ApiLink={API_URl + "/CaregiverInstantSearch"}
                                postBody={patientBody}
                                getSelectedData={handleSelectedData}
                                is={is}
                                // disabled={true}
                                placeholder={false}
                                autocomplete={false}
                            />
                        </div>
                        <div className='ar-info d-flex justify-content-center align-items-center'>
                            <p className='heading'>Info</p>
                        </div>
                    </div>
                    <div className='mb-2'>
                        <p className='text xsm_text text-danger'>This cannot be undone. Please make sure you are merging only duplicate accounts!</p>
                    </div>
                </Modal.Body>
                <ModalFooter isSaved={onClose}/>
            </Modal>
        </div>
    )
}

export default MergeCaregiver
